import Dashboard from './components/dashboard/Dashboard.vue';
import UserRegistration from './components/user/UserRegistration.vue';
import UserLogin from './components/user/UserLogin.vue';
import UserLogout from './components/user/UserLogout.vue';
import UserProfile from './components/user/UserProfile.vue';
import UserForgotPassword from './components/user/UserForgotPassword.vue';
import UserResetPassword from './components/user/UserResetPassword.vue';

import UserList from './components/user/UserList.vue';
import UserAdminEdit from './components/user/UserAdminEdit.vue';

import OrganizationProfile from './components/organizations/OrganizationProfile.vue';
import OrganizationList from './components/organizations/OrganizationList.vue';
import OrganizationEdit from './components/organizations/OrganizationEdit.vue';

import ContractModule from './components/contracts/ContractModule.vue';
import ContractSign from './components/contracts/ContractSign.vue';
import ContractDisplay from './components/contracts/ContractDisplay.vue';
import ContractEmail from './components/contracts/ContractEmail.vue';
// import ContractViaEmail from './components/contracts/ContractViaEmail.vue';
import CreditAuthorization from './components/contracts/CreditAuthorization.vue';

import EventList from './components/events/EventList.vue';
import ArchiveEventList from './components/events/ArchiveEventList.vue';
import PastEvents from './components/events/PastEvents.vue';
import EventDetail from './components/events/EventDetail.vue';

import CategoryModule from './components/categories/CategoryModule.vue';

import FestivalList from './components/festivals/FestivalList.vue';
import FestivalForm from './components/festivals/FestivalForm.vue';
import FestivalModule from './components/festivals/FestivalModule.vue';

import EventCreateModule from './components/events/EventCreateModule.vue';
import EventCreate from './components/events/steps/EventCreate.vue';
import EventCreateBasics from './components/events/steps/EventCreateBasics.vue';
import EventCreateDetails from './components/events/steps/EventCreateDetails.vue';
import EventCreateLogos from './components/events/steps/EventCreateLogos.vue';
import EventCreateTickets from './components/events/steps/EventCreateTickets.vue';
import EventCreateSubmit from './components/events/steps/EventCreateSubmit.vue';
import EventCreateDuplicate from './components/events/steps/EventCreateDuplicate.vue';
import EventCreateAdmin from './components/events/steps/EventCreateAdmin.vue';

import ResourceIndex from './components/resources/ResourceIndex.vue';
import ResourceCreate from './components/resources/steps/ResourceCreate.vue';
import ResourceCreateModule from './components/resources/ResourceCreateModule.vue';
import ResourceCreateAdmin from './components/resources/steps/ResourceCreateAdmin.vue';
import ResourceCreateBasics from './components/resources/steps/ResourceCreateBasics.vue';
import ResourceCreateDetails from './components/resources/steps/ResourceCreateDetails.vue';
import ResourceCreateTags from './components/resources/steps/ResourceCreateTags.vue';
import ResourceCreateSubmit from './components/resources/steps/ResourceCreateSubmit.vue';
import CategoryCreateEdit from "./components/categories/CategoryCreateEdit";
import RegisterPage from "./components/register/RegisterPage";
import CreateAccount from "./components/register/steps/CreateAccount";
import CreateProfile from "./components/register/steps/CreateProfile";
import JediPledge from "./components/register/steps/JediPledge";
import HomePage from "./components/home/HomePage";

export default [
  {
    path: '/',
    name: 'home-page',
    component: HomePage,
  },
  {
    path: '/my-events',
    name: 'my-events',
    component: Dashboard,
  },
  {
    path: '/register',
    component: RegisterPage,
    children: [
      {
        path: '',
        name: 'register',
        component: CreateAccount
      },
      {
        path: 'profile',
        name: 'register-create-profile',
        component: CreateProfile
      },
      {
        path: 'jedi',
        name: 'register-jedi-pledge',
        component: JediPledge
      }
    ]
  },
  {
    path: '/auth/register',
    name: 'user-registration',
    component: UserRegistration,
  },
  {
    path: '/contracts/:contract',
    name: 'contract-display',
    component: ContractDisplay
  },
  {
    path: '/signature/:key',
    name: 'contract-via-email',
    component: ContractSign
  },
  {
    path: '/auth/login',
    name: 'user-login',
    component: UserLogin,
  },
  {
    path: '/auth/logout',
    name: 'user-logout',
    component: UserLogout,
  },
  {
    path: '/auth/forgot',
    name: 'user-forgot-password',
    component: UserForgotPassword,
  },
  {
    path: '/auth/reset/:token',
    name: 'user-reset-password',
    component: UserResetPassword,
    meta: {
      'title': 'Reset Password'
    }
  },
  {
    path: '/profile',
    name: 'user-profile',
    component: UserProfile,
  },
  {
    path: '/organization',
    name: 'organization-profile',
    component: OrganizationProfile,
  },
  {
    path: '/organizations',
    name: 'organizations',
    component: OrganizationList,
  },
  {
    path: '/organizations/:id(\\d+)/edit',
    name: 'organization-edit',
    component: OrganizationEdit,
  },
  {
    path: '/categories',
    name: 'categories',
    component: CategoryModule,
  },
  {
    path: '/categories/:id(\\d+)/edit',
    name: 'category-edit',
    component: CategoryCreateEdit,
    props: true,
  },
  {
    path: '/categories/create',
    name: 'category-create',
    component: CategoryCreateEdit,
  },
  {
    path: '/events',
    name: 'event-list',
    component: EventList
  },
  {
    path: '/events/archive',
    name: 'archive-event-list',
    component: ArchiveEventList
  },
  {
    path: '/past-events',
    name: 'past-event-list',
    component: PastEvents
  },
  {
    path: '/events/:id(\\d+)',
    name: 'event-detail',
    component: EventDetail
  },
  {
    path: '/events/create',
    name: 'event-create',
    component: EventCreate
  },
  {
    path: '/events/:id',
    component: EventCreateModule,
    children: [
      {
        path: 'admin',
        name: 'events-admin',
        component: EventCreateAdmin,
        meta: {
          title: 'Admin Settings'
        }
      },
      {
        path: 'basics',
        name: 'events-basics',
        component: EventCreateBasics,
        meta: {
          title: 'Basics'
        }
      },
      {
        path: 'details',
        name: 'events-details',
        component: EventCreateDetails,
        meta: {
          title: 'Details'
        }
      },
      {
        path: 'logos',
        name: 'events-logos',
        component: EventCreateLogos,
        meta: {
          title: 'Logos'
        }
      },
      {
        path: 'logos/:lid/edit',
        name: 'events-logos-edit',
        component: EventCreateLogos
      },
      {
        path: 'ticketing',
        name: 'events-tickets',
        component: EventCreateTickets,
        meta: {
          title: 'Ticketing'
        }
      },
      {
        path: 'submit',
        name: 'events-submit',
        component: EventCreateSubmit,
        meta: {
          title: 'Event Status'
        }
      },
      {
        path: 'duplicate',
        name: 'events-duplicate',
        component: EventCreateDuplicate,
        meta: {
          title: 'Duplicate Event'
        }
      }
    ]
  },
  {
    path: '/festivals',
    name: 'festivals',
    component: FestivalList,
  },
  {
    path: '/festivals/:id(\\d+)',
    name: 'festival-module',
    component: FestivalModule,
    children: [
      {
        path: 'edit',
        name: 'festival-edit',
        component: FestivalForm
      }
    ]
  },
  {
    path: '/festivals/create',
    name: 'festival-create',
    component: FestivalForm,
  },
  {
    path: '/events/:event/contracts/:contract(\\d+)',
    name: 'contracts-module',
    component: ContractModule,
    children: [
      {
        path: 'sign',
        name: 'contract-sign',
        component: ContractSign
      },
      {
        path: 'email/:key',
        name: 'contract-email',
        component: ContractEmail
      }
    ]
  },
  {
    path: '/credit/authorization',
    name: 'credit-authorization',
    component: CreditAuthorization
  },
  {
    path: '/credit/authorization/confirmed',
    name: 'credit-authorization-confirmed',
    component: CreditAuthorization
  },
  {
    path: '/users',
    name: 'user-list',
    component: UserList
  },
  {
    path: '/users/:user/edit',
    name: 'user-admin-edit',
    component: UserAdminEdit
  },
  {
    path: '/resources',
    name: 'resource-index',
    component: ResourceIndex
  },
  {
    path: '/resources/create',
    name: 'resource-create',
    component: ResourceCreate,
    meta: {
      title: 'Resource Create'
    }
  },
  {
    path: '/resources/:id',
    name: 'resource-create-module',
    component: ResourceCreateModule,
    children: [
      {
        path: 'admin',
        name: 'resource-admin',
        component: ResourceCreateAdmin,
        meta: {
          title: 'Resource Admin Settings'
        }
      },
      {
        path: 'basics',
        name: 'resource-basics',
        component: ResourceCreateBasics,
        meta: {
          title: 'Resource Basics'
        }
      },
      {
        path: 'details',
        name: 'resource-details',
        component: ResourceCreateDetails,
        meta: {
          title: 'Resource Details'
        }
      },
      {
        path: 'tags',
        name: 'resource-tags',
        component: ResourceCreateTags,
        meta: {
          title: 'Resource Tags'
        }
      },
      {
        path: 'submit',
        name: 'resource-submit',
        component: ResourceCreateSubmit,
        meta: {
          title: 'Resource Submit'
        }
      }
    ]
  },
];
